export default function TopicsSection() {
  const topics = [
    { name: '日漫新番', heat: '128万', icon: 'ri-sun-line' },
    { name: '恋爱漫画', heat: '256万', icon: 'ri-heart-line' },
    { name: '热血战斗', heat: '189万', icon: 'ri-fire-line' },
    { name: '悬疑推理', heat: '97万', icon: 'ri-search-eye-line' },
    { name: '古风国漫', heat: '143万', icon: 'ri-brush-line' },
    { name: '韩漫精选', heat: '176万', icon: 'ri-kakao-talk-line' },
    { name: '完结佳作', heat: '312万', icon: 'ri-check-double-line' },
    { name: '奇幻异世界', heat: '85万', icon: 'ri-planet-line' },
    { name: '治愈日常', heat: '112万', icon: 'ri-cup-line' },
    { name: '校园青春', heat: '94万', icon: 'ri-book-open-line' },
  ];

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            漫迷们正在热烈讨论的话题标签，发现你最感兴趣的漫画类型
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto">
          {topics.map((topic, i) => (
            <a
              key={i}
              href="#cards"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-colors group cursor-pointer"
            >
              <div className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center group-hover:bg-accent-200 transition-colors">
                <i className={`${topic.icon} text-accent-600 text-xs`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-foreground-950 transition-colors">{topic.name}</span>
              <span className="text-xs text-foreground-400">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}